import type { T } from '@common/hooks/useTranslation';

export function workExperienceRules(t: T) {
  return {
    required: t('validations.job.workExperience.required')
  };
}
